export const DARK_THEME = "dark";
export const LIGHT_THEME = "light";

export const getTheme = () => {
  return localStorage.getItem("theme") || DARK_THEME;
}

export const setTheme = (theme) => {
  localStorage.setItem("theme", theme)
}

export const toggleTheme = () => {
  const theme = getTheme();
  if(theme === DARK_THEME) {
    setTheme(LIGHT_THEME);
  } else {
    setTheme(DARK_THEME);
  }
}